<template>
    <div
        v-if="secondaryNavType !== 'off'"
        :data-theme="secondaryColorTheme"
        :data-mode="secondaryColorPalette"
        class="surface-primary hidden md:block"
        :class="{
            'px-11 py-2': !isSidebar,
            'h-screen px-4 py-6': isSidebar,
        }"
    >
        <div
            class="flex h-full items-center justify-between"
            :class="{
                'flex-col-reverse': isSidebar,
            }"
        >
            <div
                v-if="socialLinks"
                class="flex items-center gap-2"
                :class="{
                    'flex-col': isSidebar,
                }"
            >
                <NuxtLink
                    v-for="(social, socialIndex) in socialLinks"
                    :key="socialIndex"
                    :to="social.url"
                    :target="social.target"
                    :aria-label="social.title || social.text || social.ariaLabel"
                >
                    <DButton
                        v-if="social.icon?.name"
                        :icon="iconName(social?.icon)"
                        class="social-media-button"
                        theme="transparent"
                        size="sm"
                    />
                </NuxtLink>
            </div>

            <div
                class="flex items-center gap-2"
                :class="{
                    'flex-col': isSidebar,
                }"
            >
                <DTooltip
                    v-for="(button, buttonIndex) in secondaryNavButtons"
                    :key="buttonIndex"
                    :disabled="!isSidebar"
                    placement="right"
                    arrow
                >
                    <template #trigger>
                        <NuxtLink
                            :to="button.url"
                            :target="button.target"
                        >
                            <template v-if="isSidebar">
                                <DButton
                                    v-if="button.icon?.name"
                                    :icon="iconName(button?.icon)"
                                    theme="transparent"
                                    size="sm"
                                />
                                <DButton
                                    v-else
                                    theme="transparent"
                                    size="sm"
                                />
                            </template>

                            <DButton
                                v-else-if="button.icon?.name"
                                :left-icon="iconName(button?.icon)"
                                theme="transparent"
                                size="sm"
                            >
                                {{ button.text }}
                            </DButton>
                            <DButton
                                v-else
                                theme="transparent"
                                size="sm"
                            >
                                {{ button.text }}
                            </DButton>
                        </NuxtLink>
                    </template>

                    {{ button.text }}
                </DTooltip>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { DButton, DTooltip } from '@digistorm/spark'

    const { iconName } = useIcons()

    const { getGlobalSetField, pageType } = storeToRefs(useGlobalStore())

    const socialLinks = computed(() => {
        return getGlobalSetField.value('ds_Socials_GlobalSet', 'socials_SocialLinks')
    })

    const secondaryNavType = computed(() => {
        return getGlobalSetField.value('ds_Navigation_GlobalSet', 'secondaryNav_Type') || 'off'
    })

    const secondaryColorTheme = computed(() => {
        return getGlobalSetField.value('ds_Navigation_GlobalSet', 'secondaryNav_ColorTheme')
    })

    const secondaryColorPalette = computed(() => {
        const palette =
            getGlobalSetField.value('ds_Navigation_GlobalSet', 'secondaryNav_ColorPalette') || 'brand-invert'
        switch (palette) {
            case 'color-subtle':
                return 'brand'
            case 'color-invert':
                return 'brand-invert'
            default:
                return palette
        }
    })

    const isSidebar = computed(() => {
        return pageType.value === 'home' && secondaryNavType.value === 'side-bar'
    })

    const secondaryNavButtons = computed(() => {
        return getGlobalSetField.value('ds_Navigation_GlobalSet', 'secondaryNav_Buttons')
    })
</script>
